<template>
  <div class="container mb-0 pt-0 mt-60">
  <div class="vl-parent">
        <loading v-model:active="isLoading"
                 :can-cancel="true"
                 :is-full-page="fullPage"/>
   </div>
      <div class="section-content">
        <form class="forms-sample" @submit.prevent="uploadFile"  style="width:100%">
        	<div class="form-group row">
        		<label class="col-sm-3 col-form-label" >User Name</label>
        		<div class="col-sm-9">
                    <input class="form-control" v-model="username" type="text" placeholder="User Name" required>
                 </div>
        	</div>

          
          <div class="form-group row">
            <label class="col-sm-3 col-form-label" >User Type</label>
            <div class="col-sm-9">
                <select class="form-control" v-model="type" @change="changetype($event)" required>
                    <option value="">Select User Type</option>
                    <option value="1">Super Admin</option>
                    <option value="2">Admin</option>
                </select>
            </div>

          </div>

          <div class="form-group row" v-if="districtshow">
            <label class="col-sm-3 col-form-label">Access District</label>
            <div class="col-sm-9">
                    <select class="form-control" v-model="districtid" @change="changedistrict($event)" required>
                       <option value="">Select District</option>
                       <option v-for="district in this.districtlist" :value="district.id">{{district.districtname}}</option>
                    </select>
                 </div>

          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label" >User Email</label>
            <div class="col-sm-9">
                    <input class="form-control" v-model="email" type="email" required placeholder="User Email">
                 </div>

          </div>
          <h4 v-if="role" class="card-title">User Role</h4>
            <div v-if="role" class="form-group row" v-for="prermission in this.permissionlist">
                  <label class="col-sm-3 col-form-label">{{prermission.menuname}}</label>
                  <template v-for="accessname in prermission.permission">
                  &nbsp;&nbsp;{{accessname.permissionname}} &nbsp;<input type="checkbox" v-model="selectedOptions"   :value="prermission.id+'-'+accessname.id">&nbsp;
                 </template>

            </div>
            <input class="btn btn-success mr-2" type="submit" name="submit" value="Update User">
        </form>
       </div>
   </div>
</template>
<script>
  import $ from "jquery";
  import { toast } from 'vue3-toastify';
  import 'vue3-toastify/dist/index.css';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/css/index.css';
  export default{
  	 props:['user','permissions'],
     computed:{
      url(){
      return this.$store.state.url;
      }
      },
      components: {
       Loading
      },
      data(){
        return{
           username:'',
           email:'',
           password:'',
           permissionlist:[],  
           selectedOptions:["1-1","1-2","1-3","1-4"],
           isLoading:false,
           fullPage:true,
           districtlist:[],
           districtid:0,
           type:0,
           role:false,
           districtshow:true,
           userid:0,
        }
      },
      mounted(){
        this.getallpermission();
        this.getalldistrictlist();
        this.username=this.user.name;
        this.email=this.user.email;
        this.username=this.user.name;
        this.type=this.user.type;
        this.districtid=this.user.district;
        this.role=true;
        this.userid=this.user.id;
        this.convartarray();

      },
      methods:{
       convartarray(){
       	this.selectedOptions = this.permissions.map(item => `${item.menu_id}-${item.permision_id}`);
       },
       changedistrict(event){
         this.districtid=event.target.value;
       },

       changetype(event){
         this.type=event.target.value;
         if(this.type==1){
           this.districtshow=false;
           this.role=false;
         }
         else if(this.type==2){
          this.districtshow=true;
          this.role=true;
         }
         
       },
       getallpermission(){
        axios.get(this.url+'getpermissionlist').then(response=>{
          
           this.permissionlist=response.data;

           console.log(this.permissionlist);

        })

       },
       uploadFile(){
         this.isLoading=true;
         axios.post(this.url+'updateadmin',{
         	userid:this.userid,
            selctedpermission:this.selectedOptions,
            username:this.username,
            email:this.email,
            password:this.password,
            district:this.districtid,
            type:this.type,
         }).then(response=>{
            this.isLoading=false;
            this.username="";
            this.email="";
            this.password="";
            this.districtid="";
            toast.success("User information has updated successfully", {
            autoClose: 1000,
            transition:'zoom',
            position:'top-center'
            });

            window.location.replace(this.url+'admin');
         })

       },
       getalldistrictlist(){
        axios.get(this.url+'getalldistrict/').then(response=>{
                this.districtlist=response.data;
            console.log( this.districtlist);
        })
       }

      }
  }
</script>
<style scoped>
  input[type="checkbox"] {
    position: relative;
    top: -5px;
  }
</style>